import { FunctionComponent, useMemo, type CSSProperties } from "react";

interface AlertProps {
  iONIconAalertcircleoutlin?: string;
  button: string;
  isHighlighted?: boolean;
  isHighlighted1?: boolean;
  showIONIconAalertcircleoutlin?: boolean;
  iONIconAalertcircleoutlinVisible?: boolean;
  /** Style props */
  propBackgroundColor?: CSSProperties["backgroundColor"];
  propBorder?: CSSProperties["border"];
  propColor?: CSSProperties["color"];
  onButtonClick: (label: string) => void;
  alertCountNumber?:any;
};

const Alerts: FunctionComponent<AlertProps> = ({
  button,
  isHighlighted,
  isHighlighted1,
  propBackgroundColor,
  propBorder,
  propColor,
  onButtonClick,
  alertCountNumber
}) => {
  const buttonCardStyle: CSSProperties = useMemo(() => {
    return {
      backgroundColor: propBackgroundColor,
      border: propBorder,
    };
  }, [propBackgroundColor, propBorder]);

  const buttonStyle: CSSProperties = useMemo(() => {
    return {
      color: propColor,
    };
  }, [propColor]);

  const numberStyle: CSSProperties = useMemo(() => {
    return {
      color: propColor,
    };
  }, [propColor]);

  return (
    <div
      className={`1self-stretch flex w-full flex-col items-start justify-start gap-[8px] text-left rounded-sm  text-sm
       text-black font-body-xs-semi-bold custom-lightred-bg-dv lightdoc-tabel-head-dv cursor-pointer ${isHighlighted ? "alert-item-blg" : ""}`}
      onClick={() => onButtonClick(button)} style={{ border: isHighlighted ? "" : isHighlighted1 ? "1px solid blue" : '' }}>
      <div
        className="dark-rmv-bg inner-alertliste-items-heading bg-surface-bg-red self-stretch rounded-radius-sm  flex flex-row items-center justify-start gap-[8px] border-[1px] border-solid border-surface-error"
      >
        <div className="flex-1 relative" style={buttonStyle} >
          {button}
        </div>
        <span className="my-0 relative alertcounter_cricle_dv"
        >
          <span> {alertCountNumber}</span>
        </span>
      </div>
    </div>
  );
};

export default Alerts;
